module.exports = __webpack_public_path__ + "img/25.51430e52.png";